/*
 * @Descripttion: 公用方法
 * @Author: zenghua.wang
 * @Date: 2021-06-08 10:00:18
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-03-30 14:17:56
 */
export default {
  props: {
    apiTableList: {
      type: Array,
      default: () => {
        return []
      }
    },
    apiFieldList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  provide() {
    return {
      main: this
    }
  },
  methods: {
    // 获取api可供选择的表
    loadApitableList() {
      let self = this
      let appId = this?.appId || ''
      this.$http
        .get(`/apis/main-config/queryList?appId=${appId}`)
        .then((res) => {
          if (res.code === 200) {
            if (res.data.length > 0) {
              res.data.map((item, index) => {
                self.apiTableList.push({
                  label: item.name,
                  value: item.id
                  // disabled: item.status
                })
              })
            }
          }
        })
        .catch((err) => {
          self.$message.error(err.msg)
        })
    },
    // 选择的组件是否含有传入的属性
    vaildProp(select = {}, prop) {
      return Object.prototype.hasOwnProperty.call(select, prop)
    },
    // 数值
    vaildNumber(val) {
      return typeof val === 'number' && Number.isFinite(val)
    }
  }
}
